import { useContext } from "react"
import { colors } from "source/shared/colors"
import { Icon } from "source/shared/components"
import { MapContext } from "../contexts/MapContext"

export function MapButton() {
  const { mapIsRevealed, setMapIsRevealed } = useContext(MapContext)

  return (
    <div className="ml-1">
      <button
        onClick={() => setMapIsRevealed((prev) => !prev)}
        type="button"
        style={{
          backgroundColor: colors.tint8,
          borderRadius: "4px",
          border: "0px",
          color: colors.tint2,
          fontSize: "12px",
          fontWeight: 400,
          letterSpacing: "0.025em",
          padding: "12px",
          textAlign: "left",
          textTransform: "uppercase",
          width: "128px",

          "&:focus": { outline: "none" },
        }}
      >
        <div className="d-f jc-sb ai-c">
          <div className="pr-1">
            <span className="fs-6 mr-4p">
              <Icon symbol="general#location-pin" />
            </span>
            {mapIsRevealed ? "Hide map" : "Show map"}
          </div>
          <div className="fs-3" style={{ marginTop: "-2px" }}>
            {mapIsRevealed ? "–" : "+"}
          </div>
        </div>
      </button>
    </div>
  )
}
